'use client';
import { objectWithoutProperties as _objectWithoutProperties, typeof as _typeof, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { ButtonCircle, Button as Button$2 } from './Button.styles.js';
import { BUTTON_SHAPE, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT, BUTTON_ICON_SIZE, BUTTON_PROP_TYPES } from './Button.constants.js';
import { ButtonContent } from './ButtonContent.js';

var _excluded = ["ariaLabel", "as", "children", "href", "id", "isDisabled", "isPending", "onClick", "shape", "size", "target", "title", "type", "variant", "testId"];
var defaultProps = {
  ariaLabel: undefined,
  as: 'button',
  href: undefined,
  id: undefined,
  isDisabled: false,
  isPending: false,
  onClick: function onClick() {},
  shape: BUTTON_SHAPE.PILL,
  size: BUTTON_SIZE.REGULAR,
  target: undefined,
  testId: undefined,
  title: undefined,
  type: BUTTON_TYPE.BUTTON,
  variant: BUTTON_VARIANT.PRIMARY
};
var Button = forwardRef(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps,
    ariaLabel = _ref.ariaLabel,
    as = _ref.as,
    children = _ref.children,
    href = _ref.href,
    id = _ref.id,
    isDisabled = _ref.isDisabled,
    isPending = _ref.isPending,
    onClick = _ref.onClick,
    shape = _ref.shape,
    size = _ref.size,
    target = _ref.target,
    title = _ref.title,
    type = _ref.type,
    variant = _ref.variant,
    testId = _ref.testId,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var props;
  switch (true) {
    case as === 'a':
      props = {
        href: href,
        target: target
      };
      break;
    case _typeof(as) === 'object':
      props = restProps;
      break;
    default:
      props = {
        onClick: onClick,
        type: type
      };
  }
  var iconSize = size === BUTTON_ICON_SIZE.LARGE ? BUTTON_ICON_SIZE.REGULAR : size;
  var Component = shape === BUTTON_SHAPE.CIRCLE ? ButtonCircle : Button$2;
  return React__default.createElement(Component, _extends({
    ref: ref,
    $isPending: isPending,
    $size: size,
    "aria-label": ariaLabel,
    as: as,
    id: id,
    title: title,
    $variant: variant,
    "data-testid": testId,
    disabled: isDisabled || isPending
  }, props), children, isPending && React__default.createElement(ButtonContent, {
    variant: variant,
    size: iconSize
  }));
});
Button.defaultProps = defaultProps;
Button.propTypes = BUTTON_PROP_TYPES;
var Button$1 = Button;

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
